import TableReportHelper from "report/helper"
import indicadorReportSummary from "entity/Indicador/reports/IndicadorReportSummary"

export default async function pragaSoloReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data)
    const IndicadorClass = indicador.constructor
    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null
    }

    const statusColors = (status) => {
        switch (status) {
            case "Ótimo":
                return "#6bd72d"
            case "Bom":
                return "#6bd72d"
            case "Regular":
                return "#ecdb23"
            case "Ruim":
                return "#fe4719"
            default:
                return "#fe4719"
        }
    }

    async function getChart(conformidade, status) {
        let barColor = statusColors(status)

        return h.barChart(
            {
                columns: ["Média (%)"],
                domain: [0, 4],
                width: 500,
                height: 300,
                meta: params.meta,
                series: [
                    {
                        name: "",
                        values: [conformidade],
                        props: { type: "monotone", fill: barColor }
                    }
                ],
            },
            { alignment: "center", colSpan: 3, width: 180 }
        )
    }

    return indicadorReportSummary(
        indicador,
        visita,
        tipoName,
        params,
        getChart,
        // "%", // unit
        // "conformidade",
        // params.meta, // metaShow
        // true, // showMeta
        // false, // additionalColumn
        // null // secondChartCallBack
    )
}
